import React, { useContext } from "react";
import MainBanner from "../Nosotros/MainBanner/MainBanner";
import Galeria from "./Galeria/Galeria";
import { LanguageContext } from "../../context/LanguageContext/LanguageContext";
import { proyectosMainBanner, proyectosMainBannerEn } from "../../json/proyectos/mainBannerProyectos";
import { proyectos, proyectosEn } from "../../json/proyectos/proyectos";

const Proyectos = () => {
  const { language } = useContext(LanguageContext);

  const data = language === "ES"
    ? proyectosMainBanner[0]
    : proyectosMainBannerEn[0];

  const dataGalery = language === "ES" ? proyectos : proyectosEn;

  return (
    <>
      <MainBanner {...data} />
      <Galeria dataGalery={dataGalery} />
    </>
  );
};

export default Proyectos;
